import { type FlowTextBlockConfig, FlowTextBlockConfigSchema } from 'flow-schema';

import { TextBlockFormFields } from './FormFields';
import { textBlockDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { type BlockConfigProps } from '../../types';

export const textBlockConfig: BlockConfigProps<FlowTextBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'text',
  defaultConfig: { text: '' },
  configFields: {
    schema: FlowTextBlockConfigSchema,
    getLanguageFieldValues: (config) => ({
      [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.text],
    }),
    FormFields: TextBlockFormFields,
  },
  mockDataType: 'string',
  documentationMarkdown: textBlockDocumentationMarkdown,
};
